export const isTaskSelected = (task: mumms.PatientCppTask | undefined) =>
  task ? !!(task.isselected && task.isselected === 'true') : false;
/**
  isTaskModified : has the task been modified 
  returns true if the task has been modified
 */
export const isTaskModified = (
  initialTask: mumms.PatientCppTask | undefined,
  task: mumms.PatientCppTask | undefined,
) => {
  if (initialTask && task) {
    // check if everything the same
    const taskConstant =
      initialTask.who === task.who &&
      initialTask.period === task.period &&
      initialTask.frequency === task.frequency;
    return !taskConstant;
  }
  return false;
};
